import { render, staticRenderFns } from "./UsuariosPrincipal.vue?vue&type=template&id=6de3e29d&"
import script from "./UsuariosPrincipal.vue?vue&type=script&lang=js&"
export * from "./UsuariosPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports